import { render, staticRenderFns } from "./YukiXp.vue?vue&type=template&id=070215f2&scoped=true&"
import script from "./YukiXp.vue?vue&type=script&lang=js&"
export * from "./YukiXp.vue?vue&type=script&lang=js&"
import style0 from "./YukiXp.vue?vue&type=style&index=0&id=070215f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070215f2",
  null
  
)

export default component.exports